import { login, loginByAccount, registerByPhone, getInfo,logOut } from '@/api/common'
import { setToken, removeToken } from '@/utils/auth'
import cache from '@/utils/cache'

const user = {
  state: {
    // token: getToken(),
    userId: '',
    userName:  '',
    nickName:  '',
    headImg: '',
    loginStatus: false,
  },
  //同步方法
  mutations: {
    // SET_TOKEN: (state, token) => {
    //   state.token = token
    // },
    SET_USER_ID: (state, value) => {
      // setToken('userId',userId)
      state.userId = value
      if (value) {
        cache.local.set('login_user_id', value)
      } else {
        cache.local.remove('login_user_id')
      }
    },
    SET_USER_NAME: (state, value) => {
      //setToken('name',name)
      state.userName = value
    },
    SET_NICK_NAME: (state, value) => {
      //setToken('nickName',nickName)
      state.nickName = value
    },
    SET_HEAD_IMG: (state, value) => {
      state.headImg = value
    },
    SET_LOGIN_STATUS: (state, value) => {
      //setToken('name',name)
      state.loginStatus = value
    },
  },
  //异步方法
  actions: {
    // 微信扫码登录
    Login(_ctx, code) {
      return new Promise((resolve, reject) => {
        login(code.trim()).then(res => {
          setToken(res.data.tokenValue)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 账号密码登录
    LoginByAccount({ commit }, { userName, pwd }) {
      return new Promise((resolve, reject) => {
        loginByAccount(userName.trim(), pwd.trim()).then(res => {
          setToken(res.data.tokenValue)
          if (res.data.loginId) {
            commit('SET_USER_ID', String(res.data.loginId))
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 手机号注册
    RegisterByPhone({ commit }, { phone, verifyCode, pwd }) {
      return new Promise((resolve, reject) => {
        registerByPhone(phone.trim(), verifyCode.trim(), pwd.trim()).then(res => {
          setToken(res.data.tokenValue)
          if (res.data.loginId) {
            commit('SET_USER_ID', String(res.data.loginId))
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit },userUniqueId) {
      return new Promise((resolve, reject) => {
        getInfo(userUniqueId).then(res => {
          commit('SET_USER_ID', res.data.id)
          commit('SET_USER_NAME', res.data.userName)
          commit('SET_NICK_NAME', res.data.nickName || res.data.userName)
          commit('SET_HEAD_IMG', res.data.headImg || '')
          commit('SET_LOGIN_STATUS', true)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出系统
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logOut().then(res => {
          commit('SET_USER_ID', '')
          commit('SET_USER_NAME', '')
          commit('SET_NICK_NAME', '')
          commit('SET_HEAD_IMG', '')
          commit('SET_LOGIN_STATUS', false)
          removeToken()
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default user
